module.exports = __webpack_public_path__ + "static/media/kitabisa_banner.2825ea17.jpg";